import { createFileRoute, Link } from "@tanstack/react-router";
import { TEST_BLUEPRINTS } from "@brewbase/lib";
import { RequireCapability } from "@/components/require-capability";

export const Route = createFileRoute("/analytics/blueprints/")({
  component: () => (
    <RequireCapability cap="test-template:edit">
      <RouteComponent />
    </RequireCapability>
  ),
});

/** The blueprints a method can be created from. */
function RouteComponent() {
  return (
    <div className="flex max-w-5xl flex-col gap-2 p-4">
      <p className="text-base font-medium">Blueprints</p>
      <p className="text-xs text-olive-9">
        A blueprint is a coded set of fields a test template can be created from. A template
        made from one is a method: it starts with the blueprint&apos;s fields, and each of its
        calibration curves adds a compound&apos;s fields.
      </p>
      <table className="w-full border border-olive-4 text-sm">
        <thead>
          <tr className="border-b border-olive-4 text-left text-xs text-olive-9">
            <th className="px-3 py-1 font-normal">Blueprint</th>
            <th className="px-3 py-1 font-normal">What it gives a method</th>
            <th className="px-3 py-1 font-normal text-right">Version</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(TEST_BLUEPRINTS).map((b) => (
            <tr key={b.id} className="border-b border-olive-4 align-top last:border-b-0 hover:bg-olive-2">
              <td className="px-3 py-1.5">
                <Link
                  to="/analytics/blueprints/$blueprint_id"
                  params={{ blueprint_id: b.id }}
                  className="underline-offset-2 hover:underline"
                >
                  {b.name}
                </Link>
              </td>
              <td className="px-3 py-1.5 text-xs text-olive-11">{b.summary}</td>
              <td className="px-3 py-1.5 text-right font-mono">v{b.version}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
